import PropTypes from 'prop-types'

const dishIngredientExplanationPropType = PropTypes.shape({
  id: PropTypes.string,
  text: PropTypes.string,
  originField: PropTypes.string,
  ingredientId: PropTypes.string,
  ingredientType: PropTypes.string,
})

export default dishIngredientExplanationPropType
